import * as React from "react";

import { UploadAttachment } from "../utils/ServiceManagerAPI";

import { Box, FileInput } from "grommet";
import SkeletonWrapper from "./SkeltonWrapper";

const AttachmentUpload = ({ questionId, questionnaireId, done }: { questionId: string; questionnaireId: string; done?: Function }) => {
    const [id, setId] = React.useState(Math.floor(Math.random() * 100000).toString());
    const [loading, setLoading] = React.useState(false);

    const handleContentChange = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            let content = e.target.files[i];

            if (content) {
                setLoading(true);
                var reader = new FileReader();
                reader.readAsDataURL(content);
                reader.onload = (evt: any) => {
                    UploadAttachment({
                        content: evt.target.result.replace(/^data:(\w+|\-|\/|\.)+;base64,/, ""),
                        contentType: content.type,
                        name: content.name,
                        questionId: questionId,
                        questionnaireId: questionnaireId,
                    }).then((res) => {
                        done && done(res);
                        setLoading(false);
                    });
                };
            }
        }
    };

    return (
        <Box>
            <FileInput disabled={loading} id={id} onChange={handleContentChange} multiple />
            <SkeletonWrapper loading={loading}>
                <></>
            </SkeletonWrapper>
        </Box>
    );
};
export default AttachmentUpload;
